<div class="checkbox-container">
    <div class="checkbox" 
        [ngClass]="{ 'checked' : isChecked, 'disabled' : disabled }" 
        (click)="toggleChecked()">
        <div class="checkmark w-100">
            <span class="checkmark-shape">
                <uvx-icon *ngIf="!unselectEnabled" size="checkmark" color="white">check</uvx-icon>
                <uvx-icon *ngIf="unselectEnabled" size="checkmark" color="white">remove</uvx-icon>
            </span>
        </div>
    </div>
    <label class="checkbox-label" [class.disabled]="disabled">{{ label || '' }}</label>
</div>
